import { render } from "./IndexAchat.vue?vue&type=template&id=7e89284c"
import script from "./IndexAchat.vue?vue&type=script&lang=js"
export * from "./IndexAchat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__